export default __webpack_public_path__ + "static/media/pipefy.e1e9413b.svg";